function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M562.746 252.936C549.968 226.759 521.5 213.717 501.487 192.981C478.468 169.148 467.381 136.121 453.476 105.627C439.57 75.1333 419.84 44.1702 389.116 33.5677C361.869 24.0911 332.273 32.7233 303.711 29.9084C259.082 25.4986 219.996 -0.397837 177.904 25.0294C125.853 56.4616 82.6335 102.531 50.5947 155.168C37.1591 177.218 20.8108 205.366 10.3817 234.828C-0.705 266.166 -5.02695 298.912 8.12682 327.154C29.2668 372.285 71.3589 379.041 113.827 369.752C162.684 359.149 213.138 355.771 262.84 363.465C300.704 369.376 338.099 381.105 375.587 387.297C430.739 395.648 477.153 382.137 481.475 380.448C492.373 376.413 503.93 370.971 514.923 364.403C517.46 362.902 519.996 361.307 522.439 359.712C522.533 359.618 522.721 359.524 522.815 359.431C523.567 358.961 524.318 358.399 524.976 357.929C527.231 356.428 529.392 354.833 531.459 353.144C532.868 352.112 534.184 350.986 535.593 349.86C536.345 349.203 537.096 348.64 537.848 347.984C539.163 346.858 540.479 345.732 541.7 344.512C542.452 343.855 543.109 343.198 543.861 342.448C546.116 340.29 548.277 337.944 550.344 335.598C551.19 334.566 552.129 333.534 552.975 332.502C558.988 325.09 563.78 317.114 566.974 308.576C572.987 292.156 572.799 273.485 562.746 252.936Z",
  fill: "#C1CBF9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  opacity: 0.6,
  d: "M413.43 92.4967C434.596 71.3305 434.596 37.0133 413.43 15.8471C392.264 -5.31915 357.947 -5.31917 336.78 15.847C315.614 37.0133 315.614 71.3305 336.78 92.4967C357.947 113.663 392.264 113.663 413.43 92.4967Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  d: "M391.2 79.7002C391.2 79.7002 390.1 69.7002 404.1 70.8002C404.1 70.8002 407 61.3002 417.4 60.0002C429 58.6002 432.9 67.1002 434.3 68.9002C434.3 68.9002 452.9 64.3002 455.1 79.6002H391.2V79.7002Z",
  fill: "white"
}), React.createElement("path", {
  d: "M73.5 134.9C73.5 134.9 74.3 120.8 89.5 125.2C89.5 125.2 95.4 115.7 106.3 118.4C109.9 119.3 113.1 121.5 114.9 124.8C116.2 127.2 117.1 130.6 115.9 134.9H73.5Z",
  fill: "white"
}), React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M112.2 172.5H168V230.1H213.9V344.8H158.1V344.7H134.8V344.8H87V240.3H82V233.9H87H112.2V172.5Z",
  fill: "#E8ECFF"
}), React.createElement("path", {
  d: "M224.2 194.9H181.2V344.7H224.2V194.9Z",
  fill: "#B5CCD6"
})), React.createElement("g", {
  opacity: 0.6
}, React.createElement("path", {
  d: "M449.7 201H398.7V209.2H403.2V220.3H388.2V149.5H351.8V345.7H444.5V209.2H449.7V201Z",
  fill: "#E8EBFF"
})), React.createElement("path", {
  d: "M160.8 128.8H178.5",
  stroke: "#606E97",
  strokeWidth: 2.9512,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M160.8 201.9H178.5",
  stroke: "#606E97",
  strokeWidth: 2.9512,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M160.8 163.6H178.5",
  stroke: "#606E97",
  strokeWidth: 2.9512,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M166.8 108.5H138.7V222.9H166.8V108.5Z",
  fill: "white"
}), React.createElement("path", {
  d: "M168.2 224.3H137.2V107.1H168.2V224.3ZM140.1 221.4H165.4V109.9H140.1V221.4Z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  d: "M152.699 126.182C151.746 126.182 150.888 125.983 150.125 125.584C149.371 125.177 148.777 124.613 148.344 123.894C147.911 123.175 147.694 122.36 147.694 121.45C147.694 120.54 147.911 119.725 148.344 119.006C148.777 118.287 149.371 117.728 150.125 117.329C150.888 116.922 151.746 116.718 152.699 116.718C153.531 116.718 154.281 116.865 154.948 117.16C155.615 117.455 156.17 117.879 156.612 118.434L154.974 119.916C154.385 119.205 153.67 118.85 152.829 118.85C152.335 118.85 151.893 118.958 151.503 119.175C151.122 119.392 150.823 119.699 150.606 120.098C150.398 120.488 150.294 120.939 150.294 121.45C150.294 121.961 150.398 122.416 150.606 122.815C150.823 123.205 151.122 123.508 151.503 123.725C151.893 123.942 152.335 124.05 152.829 124.05C153.67 124.05 154.385 123.695 154.974 122.984L156.612 124.466C156.17 125.021 155.615 125.445 154.948 125.74C154.281 126.035 153.531 126.182 152.699 126.182ZM151.999 139.182C150.647 139.182 149.594 138.814 148.84 138.077C148.095 137.34 147.722 136.296 147.722 134.944V129.9H150.296V134.866C150.296 136.322 150.872 137.05 152.025 137.05C153.169 137.05 153.741 136.322 153.741 134.866V129.9H156.276V134.944C156.276 136.296 155.899 137.34 155.145 138.077C154.4 138.814 153.351 139.182 151.999 139.182ZM154.908 147.255C155.428 147.437 155.836 147.723 156.13 148.113C156.425 148.494 156.572 148.958 156.572 149.504C156.572 150.301 156.252 150.917 155.61 151.35C154.969 151.783 154.042 152 152.828 152H147.914V142.9H152.568C153.73 142.9 154.614 143.117 155.22 143.55C155.827 143.975 156.13 144.551 156.13 145.279C156.13 145.712 156.022 146.102 155.805 146.449C155.597 146.787 155.298 147.056 154.908 147.255ZM150.462 144.759V146.514H152.23C153.097 146.514 153.53 146.219 153.53 145.63C153.53 145.049 153.097 144.759 152.23 144.759H150.462ZM152.62 150.141C153.522 150.141 153.972 149.833 153.972 149.218C153.972 148.603 153.522 148.295 152.62 148.295H150.462V150.141H152.62ZM153.897 163.232H150.049L149.334 165H146.708L150.725 155.9H153.26L157.29 165H154.612L153.897 163.232ZM153.143 161.334L151.973 158.422L150.803 161.334H153.143ZM156.331 168.9V178H153.757V174.451H150.247V178H147.673V168.9H150.247V172.319H153.757V168.9H156.331ZM153.992 189.232H150.144L149.429 191H146.803L150.82 181.9H153.355L157.385 191H154.707L153.992 189.232ZM153.238 187.334L152.068 184.422L150.898 187.334H153.238ZM151.999 204.182C150.647 204.182 149.594 203.814 148.84 203.077C148.095 202.34 147.722 201.296 147.722 199.944V194.9H150.296V199.866C150.296 201.322 150.872 202.05 152.025 202.05C153.169 202.05 153.741 201.322 153.741 199.866V194.9H156.276V199.944C156.276 201.296 155.899 202.34 155.145 203.077C154.4 203.814 153.351 204.182 151.999 204.182ZM151.9 217.182C151.163 217.182 150.448 217.091 149.755 216.909C149.061 216.727 148.498 216.484 148.065 216.181L148.91 214.283C149.317 214.552 149.789 214.768 150.327 214.933C150.864 215.098 151.393 215.18 151.913 215.18C152.901 215.18 153.395 214.933 153.395 214.439C153.395 214.179 153.252 213.988 152.966 213.867C152.688 213.737 152.238 213.603 151.614 213.464C150.929 213.317 150.357 213.161 149.898 212.996C149.438 212.823 149.044 212.55 148.715 212.177C148.385 211.804 148.221 211.302 148.221 210.669C148.221 210.114 148.372 209.616 148.676 209.174C148.979 208.723 149.43 208.368 150.028 208.108C150.634 207.848 151.375 207.718 152.251 207.718C152.849 207.718 153.438 207.787 154.019 207.926C154.599 208.056 155.111 208.251 155.553 208.511L154.76 210.422C153.893 209.954 153.052 209.72 152.238 209.72C151.726 209.72 151.354 209.798 151.12 209.954C150.886 210.101 150.769 210.296 150.769 210.539C150.769 210.782 150.907 210.964 151.185 211.085C151.462 211.206 151.908 211.332 152.524 211.462C153.217 211.609 153.789 211.77 154.24 211.943C154.699 212.108 155.093 212.376 155.423 212.749C155.761 213.113 155.93 213.611 155.93 214.244C155.93 214.79 155.778 215.284 155.475 215.726C155.171 216.168 154.716 216.523 154.11 216.792C153.503 217.052 152.766 217.182 151.9 217.182Z",
  fill: "url(#paint1_linear)"
}), React.createElement("path", {
  d: "M329 53.6001H208.5V73.1001H329V53.6001Z",
  fill: "#E2E7FF"
}), React.createElement("path", {
  d: "M295.798 119.471C320.573 104.515 328.533 72.3066 313.577 47.5313C298.621 22.756 266.413 14.7959 241.637 29.752C216.862 44.708 208.902 76.9166 223.858 101.692C238.814 126.467 271.023 134.427 295.798 119.471Z",
  fill: "#E2E7FF"
}), React.createElement("path", {
  d: "M235.7 52.9001C235.7 52.9001 246.2 31.7001 268.6 31.7001C291 31.7001 301.8 52.9001 301.8 52.9001H235.7Z",
  fill: "#C4DBF0"
}), React.createElement("path", {
  d: "M261.2 52.9001L256.6 51.9001L269.6 30.8L274.3 31.7001L261.2 52.9001Z",
  fill: "#DEF0FD"
}), React.createElement("path", {
  d: "M266.7 53.6001L264.2 52.1001L276.8 32.1001L279.3 33.7001L266.7 53.6001Z",
  fill: "#DEF0FD"
}), React.createElement("path", {
  d: "M304.2 54.3001H233.4L234.4 52.2001C234.5 52.0001 245.6 30.2001 268.6 30.2001C291.6 30.2001 302.7 51.3001 303.1 52.2001L304.2 54.3001ZM238.2 51.4001H299.2C295.8 46.2001 285.6 33.1001 268.6 33.1001C251.5 33.1001 241.5 46.2001 238.2 51.4001Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M270 31.7001H267.1V52.9001H270V31.7001Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M359.1 64.8999H178.5V344.4H359.1V64.8999Z",
  fill: "#E2E7FF"
}), React.createElement("path", {
  d: "M359.1 68.3999H178.5V77.7999H359.1V68.3999Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M359.1 59.8999H178.5V64.8999H359.1V59.8999Z",
  fill: "#232651"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M359.1 168.8H178.5V172.6H359.1V168.8Z",
  fill: "white"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M359.1 253H178.5V256.8H359.1V253Z",
  fill: "white"
}), React.createElement("path", {
  d: "M333.4 99.4001H309.7V148.1H333.4V99.4001Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M311.5 135.5L309.4 130.5L329.4 98.3L333.1 100.6L311.5 135.5Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M331.834 107.256L308.449 145.116L310.917 146.64L334.301 108.78L331.834 107.256Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M338 149.6H304.5V155.4H338V149.6Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M338 155.4H304.5V159.1H338V155.4Z",
  fill: "white"
}), React.createElement("path", {
  d: "M334.8 149.6H308.2V98H334.8V149.6ZM311.1 146.7H331.9V100.9H311.1V146.7Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M333.4 122.3H309.7V125.2H333.4V122.3Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M280.7 99.2002H257V147.9H280.7V99.2002Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M258.9 135.3L256.8 130.3L276.7 98.1001L280.4 100.4L258.9 135.3Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M279.145 107.073L255.76 144.934L258.227 146.458L281.612 108.597L279.145 107.073Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M285.3 149.4H251.8V155.2H285.3V149.4Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M285.3 155.2H251.8V158.9H285.3V155.2Z",
  fill: "white"
}), React.createElement("path", {
  d: "M282.1 149.4H255.5V97.8H282.1V149.4ZM258.4 146.5H279.2V100.7H258.4V146.5Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M280.7 122.1H257V125H280.7V122.1Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M228 99.2002H204.3V147.9H228V99.2002Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M206.2 135.3L204.1 130.3L224 98.1001L227.8 100.4L206.2 135.3Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M226.451 107.083L203.066 144.944L205.533 146.468L228.918 108.607L226.451 107.083Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M232.6 149.4H199.1V155.2H232.6V149.4Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M232.6 155.2H199.1V158.9H232.6V155.2Z",
  fill: "white"
}), React.createElement("path", {
  d: "M229.4 149.4H202.8V97.8H229.4V149.4ZM205.8 146.5H226.6V100.7H205.8V146.5Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M228 122.1H204.3V125H228V122.1Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M333.4 184.2H309.7V232.9H333.4V184.2Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M311.5 220.3L309.4 215.3L329.4 183.1L333.1 185.4L311.5 220.3Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M331.842 192.061L308.458 229.921L310.925 231.445L334.31 193.585L331.842 192.061Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M338 234.4H304.5V240.2H338V234.4Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M338 240.2H304.5V243.9H338V240.2Z",
  fill: "white"
}), React.createElement("path", {
  d: "M334.8 234.4H308.2V182.7H334.8V234.4ZM311.1 231.5H331.9V185.7H311.1V231.5Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M333.4 207.1H309.7V210H333.4V207.1Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M280.7 184.2H257V232.9H280.7V184.2Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M258.9 220.3L256.8 215.3L276.7 183.1L280.4 185.4L258.9 220.3Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M279.15 192.079L255.766 229.94L258.233 231.464L281.618 193.603L279.15 192.079Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M285.3 234.4H251.8V240.2H285.3V234.4Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M285.3 240.2H251.8V243.9H285.3V240.2Z",
  fill: "white"
}), React.createElement("path", {
  d: "M282.1 234.4H255.5V182.7H282.1V234.4ZM258.4 231.5H279.2V185.7H258.4V231.5Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M280.7 207.1H257V210H280.7V207.1Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M228 184.2H204.3V232.9H228V184.2Z",
  fill: "#E8EBFF"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M206.2 220.3L204.1 215.3L224 183.1L227.8 185.4L206.2 220.3Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M226.456 192.087L203.072 229.947L205.539 231.471L228.924 193.611L226.456 192.087Z",
  fill: "#C1CBF9"
}), React.createElement("path", {
  d: "M232.6 234.4H199.1V240.2H232.6V234.4Z",
  fill: "#606E97"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M232.6 240.2H199.1V243.9H232.6V240.2Z",
  fill: "white"
}), React.createElement("path", {
  d: "M229.4 234.4H202.8V182.7H229.4V234.4ZM205.8 231.5H226.6V185.7H205.8V231.5Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M228 207.1H204.3V210H228V207.1Z",
  fill: "#232651"
}), React.createElement("path", {
  d: "M321.1 273.5H216.1V344.4H321.1V273.5Z",
  fill: "#606E97"
}), React.createElement("path", {
  d: "M287.781 283.714C290.302 273.13 283.765 262.507 273.181 259.986C262.597 257.465 251.974 264.001 249.453 274.585C246.932 285.169 253.468 295.793 264.052 298.314C274.636 300.835 285.26 294.298 287.781 283.714Z",
  fill: "#606E97"
}), React.createElement("path", {
  d: "M312.1 282.1H225V344.4H312.1V282.1Z",
  fill: "#232651"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M269 284L269 343",
  stroke: "white",
  strokeWidth: 2.8383,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M423.5 279.2C423.5 273.4 421.7 268.1 418.6 263.8C417.5 262.3 417.1 260.5 417.3 258.7C417.4 257.7 417.5 256.7 417.5 255.7C417.5 244 409.4 234.6 399.5 234.6C389.5 234.6 381.5 244.1 381.5 255.7C381.5 256.7 381.6 257.7 381.7 258.7C381.9 260.5 381.5 262.3 380.4 263.8C377.3 268.1 375.5 273.4 375.5 279.2C375.5 284.8 377.2 290 380.1 294.2C381.2 295.7 381.6 297.5 381.5 299.4C381.5 299.9 381.5 300.4 381.5 300.9C381.5 312.6 389.6 322 399.5 322C409.5 322 417.5 312.5 417.5 300.9C417.5 300.4 417.5 299.9 417.5 299.4C417.4 297.5 417.9 295.7 418.9 294.2C421.7 289.9 423.5 284.8 423.5 279.2Z",
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M399.4 256H397.4V343.7H399.4V256Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M390.961 267.156L389.45 268.467L397.707 277.985L399.218 276.674L390.961 267.156Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M408.011 282.837L397.75 293.084L399.164 294.499L409.424 284.252L408.011 282.837Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M161.8 279.2C161.8 273.4 160 268.1 156.9 263.8C155.8 262.3 155.4 260.5 155.6 258.7C155.7 257.7 155.8 256.7 155.8 255.7C155.8 244 147.7 234.6 137.8 234.6C127.9 234.6 119.8 244.1 119.8 255.7C119.8 256.7 119.9 257.7 120 258.7C120.2 260.5 119.8 262.3 118.7 263.8C115.6 268.1 113.8 273.4 113.8 279.2C113.8 284.8 115.5 290 118.4 294.2C119.5 295.7 119.9 297.5 119.8 299.4C119.8 299.9 119.8 300.4 119.8 300.9C119.8 312.6 127.9 322 137.8 322C147.7 322 155.8 312.5 155.8 300.9C155.8 300.4 155.8 299.9 155.8 299.4C155.7 297.5 156.2 295.7 157.2 294.2C160.1 289.9 161.8 284.8 161.8 279.2Z",
  fill: "url(#paint3_linear)"
}), React.createElement("path", {
  d: "M137.8 256H135.8V343.7H137.8V256Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M129.351 267.146L127.84 268.457L136.097 277.975L137.608 276.664L129.351 267.146Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M146.309 282.884L136.05 293.131L137.463 294.546L147.722 284.299L146.309 282.884Z",
  fill: "#3E2D63"
}), React.createElement("path", {
  d: "M471.8 343H61V345.8H471.8V343Z",
  fill: "#3E2D63"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 143.785,
  y1: 107.1,
  x2: 165.398,
  y2: 107.964,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 147.399,
  y1: 115,
  x2: 158.566,
  y2: 115.26,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 385.697,
  y1: 234.6,
  x2: 418.986,
  y2: 237.364,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 123.997,
  y1: 234.6,
  x2: 157.286,
  y2: 237.364,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  x: 61,
  width: 410.8,
  height: 345.8,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 571,
    height: 390,
    viewBox: "0 0 571 390",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/cubahaus.fa340bb9.svg";
export { SvgComponent as ReactComponent };